import { render, staticRenderFns } from "./FiscalizacaoForm.vue?vue&type=template&id=2b075b2d&"
import script from "./FiscalizacaoForm.vue?vue&type=script&lang=js&"
export * from "./FiscalizacaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports